import { FormGroup, FormControl, Validators, NgForm } from "@angular/forms";
import { AuthService } from "./../../Auth/auth.service";
import { AngularFirestore } from "@angular/fire/firestore";
import {
  Component,
  OnInit,
  ElementRef,
  AfterViewInit,
  ViewChild,
  OnDestroy
} from "@angular/core";
import { BookServiceService } from "src/app/services/book-service.service";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { take } from "rxjs/operators";
import { ModalDirective } from "angular-bootstrap-md";

@Component({
  selector: "app-books",
  templateUrl: "./books.component.html",
  styleUrls: ["./books.component.scss"]
})
export class BooksComponent implements OnInit, OnDestroy {
  showAlert: boolean;
  isfav: boolean;
  constructor(
    private Book: BookServiceService,

    private route: ActivatedRoute,
    private fs: AngularFirestore,
    private auth: AuthService
  ) {}
  sub: Subscription;
  title = "All Books ";
  public books: any;
  isVoted;
  book;
  user;

  ngOnInit() {
    this.sub = this.Book.allBooks().subscribe(data => {
      this.books = data.map((el: any) => {
        return {
          id: el.payload.doc.id,
          ...el.payload.doc.data()
        };
      });
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
  fav(id) {
    let curBook;
    this.isfav = !this.isfav;
    this.books.map(book => {
      if (book.id === id) {
        curBook = book;
      }
    });
    this.auth.User.subscribe(data => {
      this.user = data;
      if (this.user) {
        if (this.isfav) {
          this.Book.ediBook(id).update({
            isfav: true
          });
        } else {
          this.Book.ediBook(id).update({
            isfav: false
          });
        }
      } else {
        this.showAlert = true;
        this.onOpen();
      }
    });
  }
  isOnList;
  reading() {
    this.isOnList = !this.isOnList;
  }
  voted(id) {
    let curBook;

    this.books.map(book => {
      if (book.id === id) {
        curBook = book;
      }
    });

    this.auth.User.subscribe(data => {
      this.user = data;
      if (this.user) {
        curBook.isVoted = !curBook.isVoted;
        if (curBook.isVoted) {
          curBook.rate = curBook.rate + 1;
          this.Book.ediBook(id).update({
            rate: curBook.rate,
            isVoted: true
          });
          this.isVoted = true;
        } else {
          curBook.rate = curBook.rate - 1;
          this.Book.ediBook(id).update({
            rate: curBook.rate,
            isVoted: false
          });
          this.isVoted = false;
        }
      } else {
        console.log("not sure ");
        this.showAlert = true;
        this.onOpen();
      }
    });

    // this.Book.getBook(i).then(data => {
    //   curBook = data;
    //   curBook.isVoted = !curBook.isVoted;
    //   console.log(curBook);
    //   if (curBook.isVoted) {
    //     curBook.rate = curBook.rate + 1;
    //     this.Book.ediBook(i).update({
    //       rate: curBook.rate
    //     });
    //   } else {
    //     curBook.rate = curBook.rate - 1;
    //     this.Book.ediBook(i).update({
    //       rate: curBook.rate
    //     });
    //   }
    // });

    // curBook.isVoted = !curBook.isVoted;
    // console.log(this.books[i]);
    // if (curBook.isVoted) {
    //   curBook.rate = curBook.rate + 1;
    // } else {
    //   curBook.rate = curBook.rate - 1;
    // }

    // let book: any;
    // let rate;
    // console.log(this.like);
    // this.Book.getBook(i).then(b => {
    //   book = b;
    //   this.like = book.isVoted;
    //   if (book.isVoted) {
    //     this.Book.ediBook(i).update({
    //       rate: book.rate++
    //     });
    //   } else {
    //     this.Book.ediBook(i).update({
    //       rate: book.rate--
    //     });
    //   }
    // });
    // // console.log(z.fas);
    // if (z.fas) {
    //   book.rate++;
    //   console.log(book.rate);
    // }
    //    else {
    //     book.rate--;
    //     this.Book.ediBook(i).update({
    //       rate: book.rate
    //     });
    //   }
    /*
    if (z.fas) {
      this.Book.getBook(i).then(data => {
        let book = data;
        let rate = book.rate;
        console.log(rate);

        this.Book.ediBook(i).update({
          rate: rate++
        }).then(data=>{
          console.log(data);

        });
      });
      //
    }

*/
  }
  onOpen() {
    console.log(open);
  }
}
